import { post } from "./base";

export function getBudgets(accessToken) {
  return post("budget/GetBudgets", { jsonBody: { accessToken } });
}

export function setBudget(accessToken, idAgente, year, amount) {
  return post("budget/SetBudget", {
    jsonBody: { accessToken, idAgente, anno: year, importo: amount },
  });
}

export function getExpenses(accessToken, idAgente, year) {
  return post("budget/GetExpenses", {
    jsonBody: { accessToken, idAgente, anno: year },
  });
}
